import React from "react";

export default function WarningIcon(props?: any) {

  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
  .filter(key => svgStyles[key] !== null && svgStyles[key] !== undefined)
  .reduce((acc: any, key) => {
    acc[key] = svgStyles[key];
    return acc;
  }, {});

  return (
    <svg  viewBox="0 0 34 32" fill="none" 
    style={{...filteredStyles, fill : "none"}}
    className={props.className}
    xmlns="http://www.w3.org/2000/svg">
    <path d="M33.3075 24.3692L21.5324 2.72362C19.6406 -0.46134 15.0288 -0.465572 13.1344 2.72362L1.3599 24.3692C-0.57408 27.6237 1.76739 31.7449 5.55795 31.7449H29.1085C32.8959 31.7449 35.2415 27.627 33.3075 24.3692ZM17.3334 27.8387C16.2567 27.8387 15.3803 26.9622 15.3803 25.8855C15.3803 24.8089 16.2567 23.9324 17.3334 23.9324C18.4101 23.9324 19.2865 24.8089 19.2865 25.8855C19.2865 26.9622 18.4101 27.8387 17.3334 27.8387ZM19.2865 20.0262C19.2865 21.1029 18.4101 21.9793 17.3334 21.9793C16.2567 21.9793 15.3803 21.1029 15.3803 20.0262V10.2605C15.3803 9.18385 16.2567 8.30741 17.3334 8.30741C18.4101 8.30741 19.2865 9.18385 19.2865 10.2605V20.0262Z" fill={filteredStyles.fill}/>
    </svg>
    
  )
}
